// Route base for the change management V2 prototype. V1 owns `/changes`, so V2
// lives under its own base path to keep the two mock-ups fully separate.
export const CHANGE_V2_BASE_PATH = '/change-v2';

export const getChangeV2DashboardPath = (): string => CHANGE_V2_BASE_PATH;
export const getChangeV2CreatePath = (): string => `${CHANGE_V2_BASE_PATH}/new`;
export const getChangeV2WorkspacePath = (changeId: string): string => `${CHANGE_V2_BASE_PATH}/${changeId}`;
export const getChangeV2RequestPath = (changeId: string): string => `${CHANGE_V2_BASE_PATH}/${changeId}/request`;
export const getChangeV2AssessmentPath = (changeId: string): string => `${CHANGE_V2_BASE_PATH}/${changeId}/assessment`;
export const getChangeV2PlanPath = (changeId: string): string => `${CHANGE_V2_BASE_PATH}/${changeId}/plan`;
export const getChangeV2ExecutionPath = (changeId: string): string => `${CHANGE_V2_BASE_PATH}/${changeId}/execution`;
export const getChangeV2CompletionPath = (changeId: string): string => `${CHANGE_V2_BASE_PATH}/${changeId}/completion`;

// The V2 mock is surfaced in the nav when the organization enables it, mirroring
// how the V1 change mock is gated by its own config block.
export type TChangeV2MockConfig = { enabled?: boolean } | undefined;

export const isChangeV2MockVisible = (config: TChangeV2MockConfig): boolean => Boolean(config?.enabled);
